/**
 * @generated SignedSource<<3b49cc8c95ee0793d8e68cc09a526d4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserBelongsToCurrentClub_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useUserBelongsToCurrentClub_session";
};
export type useUserBelongsToCurrentClub_session$key = {
  readonly " $data"?: useUserBelongsToCurrentClub_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserBelongsToCurrentClub_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserBelongsToCurrentClub_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "a2240ee3c527fb93dcb6120abdbe82c1";

export default node;
